// General
import React, { useContext } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { TextField, MenuItem } from "@mui/material";
// Formik
import { Formik, Form } from "formik";
// Contexts
import { DealersContext } from "../../data/dealers/DealersContex";
import { useValidations } from "../../data/ValidationContext";


const DealersUpdateModal = ({ isOpen, onClose, dealerId }) => {
  // Contextten bayi listesi ve güncelleme fonksiyonunu al
  const { dealersList, updateDealer } = useContext(DealersContext);
  // Güncellenecek bayi
  const dealer = dealersList.find((d) => d.id === dealerId);
  // Validation
  const { vs_dealer } = useValidations();

  if (!dealer) return null;

  // Formik başlangıç değerleri
  const initialValues = { name: dealer.name, status: dealer.status };

  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      {/* Formik setup */}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={vs_dealer}
        onSubmit={(values) => {
          updateDealer(dealerId, values);
          onClose();
        }}
      >
        {({ values, errors, touched, handleChange }) => (
          <Form>
            {/* Modal Header */}
            <Modal.Header closeButton>
              <Modal.Title>Bayi Güncelle</Modal.Title>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body>
              {/* Bayi Adı */}
              <div className="mb-3">
                <TextField
                  label="Bayi Adı"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />
              </div>

              {/* Durum Seçimi */}
              <div>
                <TextField
                  select
                  label="Durum"
                  name="status"
                  value={values.status}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.status && !!errors.status}
                  helperText={touched.status && errors.status}
                >
                  <MenuItem value="Aktif">Aktif</MenuItem>
                  <MenuItem value="Pasif">Pasif</MenuItem>
                </TextField>
              </div>
            </Modal.Body>

            {/* Modal Footer */}
            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Güncelle
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DealersUpdateModal;
